import {
  Flexbox, ListManager, PageHeader, Styles, Card,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import FilterAdoptions from '../../components/FilterAdoptions'

function MonthlyAdoptionsByFairManualAndDirect({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(
    reports.monthlyAdoptionsByFairManualAndDirect,
    query,
  )

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Adoções mensais por feira, manuais e diretas"
        subtitle="Quantidade de adoções confirmadas por mês, agrupadas por feiras, adoções diretas e adoções manuais"
        icon="fas fa-dog"
        rightAction={() => <FilterAdoptions donors={data?.donors} />}
      />
      <ListManager count={data?.count || 0} loading={loading} error={error}>
        <div className="p-2">
          <div className="text-small">
            <b className="text-primary">*Adoções manuais: </b>
            <span>
              registros inseridos manualmente pela administração, visando
              registrar adoções que ocorreram anteriormente ou fora do sistema
              Petis.
            </span>
          </div>
          <div className="text-small">
            <b className="text-primary">**Adoções diretas: </b>
            <span>
              realizadas fora de feiras de adoção, quando o doador entrega o
              animal diretamente ao adotante.
            </span>
          </div>
          <div className="p-2 bg-gray s-rounded mt-2">
            <div className="text-small">
              <span>
                Este relatório contabiliza as adoções confirmadas de pets doados pelo parceiro
                e também por pessoas com permissão de feira.
              </span>
            </div>
          </div>
        </div>
        <Flexbox.Columns>
          <Flexbox.Column className="col-sm-12 my-2">
            <Card.Base>
              <Card.Header>
                <Flexbox.Columns className="align-center col-gapless">
                  <Flexbox.Column className="ml-2">
                    <b>Quantidade total de adoções confirmadas por ano</b>
                  </Flexbox.Column>
                </Flexbox.Columns>
              </Card.Header>
              <Card.Body>
                <div className="divider" />
                <table className="table table-hover text-small">
                  <thead>
                    <tr>
                      <th>Ano</th>
                      <th width="100px" className="text-right">
                        Quantidade
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.results?.map((item) => (
                      <tr key={item?.year}>
                        <td>{item?.year}</td>
                        <td className="text-right">
                          {item?.annualAdoptionsCount}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Card.Body>
            </Card.Base>
          </Flexbox.Column>
        </Flexbox.Columns>
        <Flexbox.Columns>
          {Boolean(data)
            && data.rows.map((item) => (
              <Flexbox.Column
                key={item?.month}
                className="col-6 col-sm-12 my-2"
              >
                <Card.Base>
                  <Card.Header>
                    <Flexbox.Columns className="align-center">
                      {Boolean(item.month) && (
                        <Flexbox.Column className="col-auto">
                          <i className="fas fa-calendar fa-lg" />
                        </Flexbox.Column>
                      )}
                      <Flexbox.Column>
                        <div className="h5">{item?.monthString}</div>
                      </Flexbox.Column>
                    </Flexbox.Columns>
                  </Card.Header>
                  <Card.Body>
                    <table className="table table-hover text-small">
                      <thead>
                        <tr>
                          <th>Feira</th>
                          <th width="100px" className="text-right">
                            Adoções confirmadas
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {item.fairs.map((fair) => (
                          <tr key={fair?.fairId}>
                            <td>{fair.fairTitle}</td>
                            <td className="text-right">{fair.adoptionCount}</td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td />
                          <td className="text-bold text-primary text-right">
                            Total: {item.adoptionsTotal}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </Card.Body>
                </Card.Base>
              </Flexbox.Column>
            ))}
        </Flexbox.Columns>
      </ListManager>
    </Styles.Container>
  )
}

export default MonthlyAdoptionsByFairManualAndDirect
